import React from "react";
import { useTranslation } from "react-i18next";
import { useLegalDocument } from "../../hooks/useLegalDocument";
import LegalDocumentBody from "./LegalDocumentBody";

/**
 * Public Privacy Policy page.
 */
const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();
  const { doc: privacyDoc } = useLegalDocument("privacy_policy");

  return (
    <div className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4">
        <h1 className="text-3xl font-extrabold text-[#333] md:text-4xl">
          {privacyDoc?.title || t("Privacy Policy")}
        </h1>
        <div className="mt-6">
          <LegalDocumentBody
            doc={privacyDoc}
            fallback={
              <div className="space-y-4 leading-relaxed text-gray-600">
                <p>
                  {t("We collect the information you provide when creating an account, such as your university email and profile details.")}
                </p>
                <p>
                  {t("We use your data to provide, maintain and improve our services.")}
                </p>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;